<script>
    import { Router } from 'svelte-router-spa'
    import { routes } from './routes'
    import Header from './Components/Header.svelte'

    let primary
    if (process.env.PRIMARY_COLOR) {
        primary = process.env.PRIMARY_COLOR
    } else {
        primary = "#1600ff"
    }
</script>

<main>
    <div class="app" style="--primary-color: {primary}">
        <Header/>
        <Router {routes}/>
    </div>
</main>

<style>
    :global(body) {
        font-family: "Arimo", sans-serif;
        color: #161616;
    }

    :global(h1, h2, h3, h4, h5, h6) {
        font-family: "Arimo", sans-serif;
        font-weight: 700;
    }

    :global(.body) {
        padding-left: 8%;
        padding-right: 8%;
        padding-top: 58px;
        padding-bottom: 24px;
        max-width: 760px;
        margin: 0 auto;
    }

    :global(.content) {
        margin-bottom: 76px;
    }

    :global(.btn) {
        padding: 12px;
        color: var(--primary-color);
        border: solid 1px #888888;
        display: inline-block;
        margin-top: 12px;
    }

    :global(.btn-primary) {
        border: none;
        color: #ffffff !important;
        background: var(--primary-color);
    }

    :global(input, textarea) {
        width: 100%;
    }

    :global(.e) {
        font-weight: 700
    }

    :global(.f) {
        color: #333333 !important;
    }
</style>